// Mock data for the company website

export const companyInfo = {
  name: "Hexalogix Automation",
  tagline: "Precision, Power, Performance",
  email: "info@hexalogixautomation.com",
  emailSales: "sales.mea1@hexalogixautomation.com",
  phone: {
    india: "+91 9995009311",
    uae: "+971 55 916 2533",
    ajman: "+971 56 664 0618"
  },
  address: {
    india: "Building No 13/474 R, 2nd Floor, Valiyara Arcade, UC College P.O, Aluva – 683102, Kerala, India",
    dubai: "411/46, Pinnacle Building, Al Barsha First, Sheik Zayed Road, Dubai, UAE",
    ajman: "Shed No: 1, Al Bahia, Ajman, UAE"
  },
  social: {
    linkedin: "https://linkedin.com/company/hexalogix-automation",
    twitter: "https://twitter.com/hexalogix",
    facebook: "https://facebook.com/hexalogixautomation",
    instagram: "https://instagram.com/hexalogixautomation"
  }
};

export const services = [
  {
    id: 1,
    slug: "plc",
    title: "PLC Programming Services in UAE & Africa",
    description: "PLC programming services using Siemens, Allen Bradley, Schneider, and Delta platforms for UAE and Africa industrial automation projects.",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&h=800&fit=crop&q=80",
    features: ["PLC Programming (Siemens, Schneider, Allen-Bradley, Delta)", "HMI & SCADA System Development", "VFD Integration & Motor Control", "Remote Monitoring & Data Logging"]
  },
  {
    id: 2,
    slug: "scada",
    title: "SCADA Development UAE & Africa",
    description: "SCADA development for real-time monitoring, control, alarms, dashboards, and data visualization across UAE and Africa industrial systems.",
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=1200&h=800&fit=crop&q=80",
    features: ["Real-Time Process Visualization", "Historian & Alarm Management", "Multi-Site Monitoring Dashboards", "PLC, HMI & Field Device Integration"]
  },
  {
    id: 3,
    slug: "bms",
    title: "BMS & HVAC Automation UAE & Africa",
    description: "BMS and HVAC automation solutions for smart control of HVAC, lighting, utilities, and energy systems in UAE and Africa.",
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1200&h=800&fit=crop&q=80",
    features: ["HVAC Controls & Scheduling", "Energy Monitoring & Reporting", "Lighting & Utility Integration", "Smart Building Alarm Management"]
  },
  {
    id: 4,
    slug: "control-panels",
    title: "Control Panel & Switchgear Manufacturing UAE",
    description: "Control panel manufacturing and low-voltage switchgear support for PLC panels, MCC panels, and automation enclosures in UAE and Africa.",
    image: "https://images.unsplash.com/photo-1581092335397-9583eb92d232?w=1200&h=800&fit=crop&q=80",
    features: ["PLC, MCC & Relay Logic Panels", "Custom Panel Design & Fabrication", "FAT, SAT & Documentation", "Site Installation Support"]
  },
  {
    id: 5,
    slug: "testing-commissioning",
    title: "Testing, Commissioning & Site Support",
    description: "Comprehensive on-site support including commissioning, troubleshooting, loop checking, and electrical installation supervision.",
    image: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=1200&h=800&fit=crop&q=80",
    features: ["Pre-commissioning & Commissioning", "On-site PLC/HMI Modifications", "Loop Checking & Functional Testing", "Electrical Installation Supervision"]
  },
  {
    id: 6,
    slug: "turnkey",
    title: "Turnkey Automation Solutions UAE & Africa",
    description: "End-to-end automation project execution from concept to commissioning, including design, fabrication, programming, and documentation.",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1200&h=800&fit=crop&q=80",
    features: ["Design to Delivery Execution", "Panel Fabrication & Programming", "Complete Documentation", "Legacy System Retrofit & Upgrade"]
  }
];

export const serviceDetails = {
  plc: {
    slug: "plc",
    title: "PLC Programming Services in UAE & Africa",
    seoTitle: "PLC Programming Services in UAE & Africa | Siemens, Allen Bradley",
    seoDescription: "PLC programming services in UAE and Africa for Siemens S7, Allen Bradley, Schneider and Delta PLC industrial automation projects.",
    keywords: "PLC programming services UAE, PLC programming services Africa, PLC programmer UAE, Allen Bradley PLC UAE, Siemens PLC programming UAE, industrial automation company UAE",
    heroImage: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=1920&h=600&fit=crop&q=80",
    heroDescription: "Expert PLC programming using Siemens, Allen Bradley, Schneider, and Delta platforms for reliable industrial automation across the UAE and Africa.",
    introTitle: "Reliable Control Logic for Demanding Operations",
    introBody: [
      "PLC programming is the foundation of modern industrial automation. At Hexalogix Automation, we design, program, test, and commission PLC control systems for manufacturing plants, HVAC systems, utilities, marine installations, and process industries across the UAE and Africa.",
      "Our engineers deliver structured, maintainable logic with clear diagnostics, operator-friendly HMI integration, and dependable field performance. Whether the requirement is a new automation package, retrofit, or plant expansion in UAE or Africa, we tailor the control strategy to your exact process."
    ],
    highlightPoints: [
      "Siemens S7, Allen Bradley, Schneider, and Delta PLC programming",
      "Structured sequences, interlocks, alarms, and permissives",
      "Integration with SCADA, HMI, VFDs, instrumentation, and remote I/O",
      "Factory testing, site commissioning, and post-startup support"
    ],
    expertiseTitle: "Platforms We Support",
    expertiseItems: [
      { title: "Siemens S7", description: "TIA Portal engineering for S7-1200, S7-1500, and legacy S7 platforms with PROFINET and safety integration.", bullets: ["TIA Portal development", "Drive and motion integration", "Safety logic and diagnostics"] },
      { title: "Allen Bradley", description: "Studio 5000 and Logix programming for ControlLogix, CompactLogix, and MicroLogix applications.", bullets: ["EtherNet/IP architecture", "Batch and process control", "Migration from legacy PLCs"] },
      { title: "Schneider & Delta", description: "Flexible PLC programming for OEM machinery, utility systems, and cost-sensitive automation packages.", bullets: ["Modbus TCP/RTU integration", "Energy and utility control", "Compact machine automation"] }
    ],
    industriesTitle: "Industries We Serve",
    industries: ["Oil & Gas", "Manufacturing", "HVAC Systems", "Water Treatment", "Infrastructure", "Food & Beverage", "Pharmaceutical", "Marine & Offshore"],
    processTitle: "Our PLC Delivery Process",
    process: [
      { step: "01", title: "Process Study", desc: "We review your sequence, I/O list, field architecture, and operational priorities." },
      { step: "02", title: "Programming", desc: "Our team develops scalable PLC code, HMI screens, alarms, and network structure." },
      { step: "03", title: "Testing", desc: "We simulate logic, verify interlocks, and perform FAT before site deployment." },
      { step: "04", title: "Commissioning", desc: "We support startup, tuning, troubleshooting, and operator handover on site." }
    ],
    caseStudy: {
      title: "Production Line Automation Upgrade",
      description: "For a manufacturing client in the UAE, we upgraded an aging control architecture to Siemens S7-1500 PLCs with HMI and VFD integration, improving uptime and reducing troubleshooting time.",
      metrics: [
        { label: "Project Duration", value: "8 weeks" },
        { label: "Production Lines", value: "12 lines" },
        { label: "Downtime Reduction", value: "60%" },
        { label: "Efficiency Gain", value: "35%" }
      ]
    },
    faqs: [
      { question: "Which PLC brands do you support?", answer: "We work with Siemens, Allen Bradley, Schneider Electric, Delta, and other major PLC platforms used in industrial automation projects." },
      { question: "Can you modify an existing PLC program?", answer: "Yes. We handle troubleshooting, code cleanup, sequence modification, expansion work, and migration from legacy controllers." },
      { question: "Do you provide PLC programming services in UAE and Africa?", answer: "Yes. We provide PLC programming, FAT, SAT, startup, loop checking, tuning, and site commissioning support across UAE and Africa projects." }
    ],
    ctaTitle: "Need PLC Programming Support for Your Facility?",
    ctaText: "Talk to our automation engineers about new control systems, retrofits, troubleshooting, and commissioning."
  },
  scada: {
    slug: "scada",
    title: "SCADA Development Services in UAE & Africa",
    seoTitle: "SCADA Development UAE & Africa | SCADA System Integrator",
    seoDescription: "SCADA development services in UAE and Africa for real-time monitoring, alarms, trends, historian integration, dashboards and remote visibility.",
    keywords: "SCADA development UAE, SCADA development Africa, SCADA system integrator UAE, industrial SCADA solutions UAE, SCADA integration Africa, process monitoring systems UAE",
    heroImage: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=1920&h=600&fit=crop&q=80",
    heroDescription: "Centralized SCADA solutions for real-time monitoring, alarm handling, reporting, and operational visibility across UAE and Africa industrial systems.",
    introTitle: "Real-Time Visibility for Critical Operations",
    introBody: [
      "A strong SCADA system gives operators the information they need to act quickly, reduce downtime, and manage process performance with confidence. Hexalogix designs SCADA architectures for UAE and Africa projects that connect PLCs, HMIs, analyzers, field devices, and reporting tools into one clear operating layer.",
      "We build operator-friendly interfaces with process mimic diagrams, historical trending, alarm management, role-based access, and remote monitoring capabilities tailored to the site."
    ],
    highlightPoints: [
      "Custom SCADA graphics, alarm logic, and historian configuration",
      "Integration with PLCs, RTUs, meters, analyzers, and VFDs",
      "Reports, trends, KPI dashboards, and remote user access",
      "Migration and modernization of outdated SCADA systems"
    ],
    expertiseTitle: "SCADA Capabilities",
    expertiseItems: [
      { title: "Operator Dashboards", description: "Clear process screens, navigation structure, summary dashboards, and plant-wide overviews for faster decision making.", bullets: ["Graphic mimic development", "Role-based operator views", "Alarm prioritization"] },
      { title: "Data & Reporting", description: "Historian setup, trend archives, event logs, and production or utility reports for operations and management.", bullets: ["Trend analysis", "Batch/event records", "Performance reporting"] },
      { title: "Remote Monitoring", description: "Secure access for plant managers, service teams, and multi-site monitoring environments.", bullets: ["Remote dashboards", "VPN-ready architectures", "Multi-site visibility"] }
    ],
    industriesTitle: "Where SCADA Adds Value",
    industries: ["Water & Wastewater", "Manufacturing", "Utilities", "Oil & Gas", "Energy", "HVAC Plants", "Infrastructure", "Marine Systems"],
    processTitle: "How We Deliver SCADA Projects",
    process: [
      { step: "01", title: "System Review", desc: "We assess PLC architecture, process flow, operator needs, and reporting requirements." },
      { step: "02", title: "Screen Design", desc: "We build process graphics, navigation, alarms, and historian structures around real workflows." },
      { step: "03", title: "Integration", desc: "The SCADA layer is connected to field controllers, reports, notifications, and remote access tools." },
      { step: "04", title: "Validation", desc: "We test the full monitoring stack, fine-tune alarms, and support operator training and handover." }
    ],
    caseStudy: {
      title: "Central Monitoring for Utility Assets",
      description: "We delivered a SCADA monitoring platform for distributed utility equipment, combining live status, alarm escalation, historical trends, and site-by-site reporting in one interface.",
      metrics: [
        { label: "Connected Assets", value: "40+" },
        { label: "Operator Screens", value: "25" },
        { label: "Alarm Response", value: "Faster by 45%" },
        { label: "Reporting Scope", value: "Multi-site" }
      ]
    },
    faqs: [
      { question: "What is included in your SCADA development service?", answer: "We handle architecture review, graphic development, alarm setup, historian integration, reports, communications, testing, and commissioning support." },
      { question: "Can you upgrade an old SCADA system?", answer: "Yes. We modernize outdated SCADA environments, improve usability, and help migrate legacy systems with minimal disruption." },
      { question: "Do you provide SCADA development in UAE and Africa?", answer: "Yes. We provide SCADA development, PLC/HMI integration, dashboards, alarms, trends, and remote monitoring support for UAE and Africa industrial projects." }
    ],
    ctaTitle: "Planning a SCADA Upgrade or New Monitoring System?",
    ctaText: "Let’s design a SCADA platform that gives your team better visibility, faster response, and cleaner reporting."
  },
  bms: {
    slug: "bms",
    title: "BMS & HVAC Automation Services in UAE & Africa",
    seoTitle: "BMS & HVAC Automation UAE & Africa | BMS Solutions",
    seoDescription: "BMS and HVAC automation services in UAE and Africa for energy-efficient control of HVAC, lighting, utilities and building systems.",
    keywords: "BMS solutions UAE, BMS solutions Africa, building management system UAE, HVAC automation UAE, HVAC automation company UAE, BMS integration UAE, smart building controls UAE",
    heroImage: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1920&h=600&fit=crop&q=80",
    heroDescription: "Smart building control solutions for HVAC, chilled water systems, lighting, utilities, and energy management in UAE and Africa facilities.",
    introTitle: "Better Comfort, Efficiency, and Energy Control",
    introBody: [
      "A well-engineered Building Management System helps facility teams control comfort, reduce waste, and improve operational reliability. Hexalogix designs and integrates BMS solutions for office towers, industrial buildings, hospitality projects, data centers, and critical facilities in the UAE and Africa.",
      "We develop practical control strategies for HVAC equipment, air handling units, chilled water plants, pumps, fans, lighting, and energy monitoring with clear dashboards and dependable alarm management."
    ],
    highlightPoints: [
      "HVAC automation for AHUs, FCUs, chillers, pumps, and ventilation systems",
      "Energy monitoring, scheduling, and utility optimization",
      "Alarm management and centralized facility visibility",
      "Integration with third-party controllers and smart building systems"
    ],
    expertiseTitle: "BMS Solution Scope",
    expertiseItems: [
      { title: "HVAC Controls", description: "Control logic for airside and waterside systems to maintain comfort, stability, and energy efficiency.", bullets: ["AHU and FCU control", "Chiller plant sequencing", "Pump and fan optimization"] },
      { title: "Energy Management", description: "Monitoring tools that help facility teams track consumption, demand patterns, and performance opportunities.", bullets: ["Meter integration", "Energy dashboards", "Scheduling and setbacks"] },
      { title: "Facility Integration", description: "Centralized building views that bring multiple building systems together under one operating interface.", bullets: ["Lighting integration", "Utility system monitoring", "Alarm and notification setup"] }
    ],
    industriesTitle: "Ideal for Facilities Such As",
    industries: ["Commercial Buildings", "Hotels", "Hospitals", "Data Centers", "Industrial Facilities", "Educational Campuses", "Retail Complexes", "Mixed-Use Developments"],
    processTitle: "Our BMS Project Workflow",
    process: [
      { step: "01", title: "Facility Assessment", desc: "We review the building services, control philosophy, and integration requirements." },
      { step: "02", title: "Control Design", desc: "We prepare points lists, network architecture, graphics, sequences, and alarm logic." },
      { step: "03", title: "Integration", desc: "Controllers, meters, HVAC equipment, and third-party interfaces are brought into the BMS platform." },
      { step: "04", title: "Optimization", desc: "We commission the system, fine-tune performance, and support operation and maintenance teams." }
    ],
    caseStudy: {
      title: "HVAC Energy Optimization for a Commercial Facility",
      description: "For a large commercial property, we implemented BMS control and monitoring for air handling, pumps, and chilled water systems, improving visibility and reducing unnecessary runtime.",
      metrics: [
        { label: "Facility Type", value: "Commercial" },
        { label: "Integrated Points", value: "1,500+" },
        { label: "Energy Savings", value: "18%" },
        { label: "Alarm Visibility", value: "Centralized" }
      ]
    },
    faqs: [
      { question: "What systems can your BMS integrate?", answer: "We typically integrate HVAC equipment, pumps, meters, lighting-related controls, and selected utility systems based on project scope." },
      { question: "Do you provide BMS retrofit services?", answer: "Yes. We help modernize older buildings by upgrading graphics, control logic, interfaces, and system visibility while preserving practical field assets where possible." },
      { question: "Do you provide BMS and HVAC automation in UAE and Africa?", answer: "Yes. We deliver BMS solutions and HVAC automation for commercial, industrial, hospitality, and critical facilities across UAE and Africa projects." }
    ],
    ctaTitle: "Need Smarter Building Control?",
    ctaText: "Let’s design a BMS solution that improves HVAC performance, facility visibility, and energy efficiency."
  },
  "control-panels": {
    slug: "control-panels",
    title: "Control Panel & Switchgear Manufacturing in UAE",
    seoTitle: "Control Panel & Switchgear Manufacturing UAE | PLC Panel Builders",
    seoDescription: "Control panel manufacturing and low-voltage switchgear support in UAE and Africa for PLC panels, MCC panels, automation enclosures and FAT/SAT.",
    keywords: "control panel manufacturing UAE, control panel manufacturer UAE, switchgear manufacturing UAE, low voltage switchgear UAE, PLC control panel builders UAE, MCC panel manufacturer UAE, automation panels UAE, control panel manufacturing Africa",
    heroImage: "https://images.unsplash.com/photo-1581092335397-9583eb92d232?w=1920&h=600&fit=crop&q=80",
    heroDescription: "Custom-built control panels and low-voltage switchgear support engineered for automation, power distribution, process control, and field-ready UAE and Africa installations.",
    introTitle: "Built for Reliability, Safety, and Maintainability",
    introBody: [
      "Control panel quality has a direct effect on project reliability, maintainability, and commissioning speed. Hexalogix designs and manufactures control panels and supports low-voltage switchgear requirements for industrial automation, building systems, utilities, and OEM applications in the UAE and Africa.",
      "From layout and component selection to assembly, wiring, testing, and documentation, we deliver PLC panels, MCC panels, automation enclosures, and switchgear-related panel packages that are practical to install, easy to service, and aligned with project standards."
    ],
    highlightPoints: [
      "PLC panels, MCC panels, relay logic panels, low-voltage switchgear support, and custom automation enclosures",
      "Component selection, GA drawings, schematics, and as-built documentation",
      "FAT support, I/O verification, labeling, and quality checks",
      "Coordination with site teams for installation and commissioning"
    ],
    expertiseTitle: "Control Panel & Switchgear Scope",
    expertiseItems: [
      { title: "PLC & Automation Panels", description: "Purpose-built panels for control logic, HMI integration, remote I/O, and communication-ready automation systems.", bullets: ["PLC and HMI integration", "Network-ready layouts", "Field-friendly terminations"] },
      { title: "MCC & Switchgear Panels", description: "Panels designed for motor control, low-voltage switchgear support, power distribution, and operational safety in demanding industrial environments.", bullets: ["MCC arrangements", "Low-voltage switchgear support", "Drive and starter integration"] },
      { title: "Custom Enclosures", description: "Project-specific enclosures for OEM packages, skids, utilities, and retrofit work.", bullets: ["Compact or large-format builds", "Environmental considerations", "Custom labeling and documentation"] }
    ],
    industriesTitle: "Applications We Support",
    industries: ["Manufacturing", "Utilities", "HVAC Plants", "Water Treatment", "Marine Packages", "Process Skids", "Infrastructure", "Commercial Projects"],
    processTitle: "Our Control Panel Manufacturing Workflow",
    process: [
      { step: "01", title: "Engineering Review", desc: "We define the panel scope, load requirements, I/O, component strategy, and drawings." },
      { step: "02", title: "Fabrication", desc: "Our team assembles, wires, labels, and verifies the panel to the approved design package." },
      { step: "03", title: "Testing", desc: "We carry out continuity checks, I/O verification, and FAT preparation before delivery." },
      { step: "04", title: "Support", desc: "We assist with installation, commissioning coordination, and as-built documentation handover." }
    ],
    caseStudy: {
      title: "Custom PLC Panel Package for Utility Application",
      description: "We delivered a set of custom PLC and control panels for a utility automation package, including documentation, FAT support, and commissioning coordination for smooth deployment.",
      metrics: [
        { label: "Panels Delivered", value: "14" },
        { label: "Project Type", value: "Utility Automation" },
        { label: "Testing Stage", value: "FAT Completed" },
        { label: "Documentation", value: "Full Package" }
      ]
    },
    projectImages: [
      {
        src: "/project-images/low-voltage-switchgear-control-panel-uae.webp",
        alt: "Low-voltage switchgear control panel manufactured in UAE by Hexalogix Automation",
        title: "Low-Voltage Switchgear Panel"
      },
      {
        src: "/project-images/control-panel-manufacturing-uae.webp",
        alt: "Control panel manufacturing in UAE with PLC modules and industrial wiring",
        title: "PLC Control Panel Build"
      },
      {
        src: "/project-images/plc-control-panel-wiring-uae.webp",
        alt: "PLC control panel wiring for UAE and Africa automation projects",
        title: "PLC Panel Wiring"
      },
      {
        src: "/project-images/switchgear-control-panel-uae.webp",
        alt: "Switchgear control panel with breakers, relays, and field terminals in UAE",
        title: "Switchgear Control Panel"
      },
      {
        src: "/project-images/automation-panel-hmi-uae.webp",
        alt: "Automation panel with HMI interface manufactured for UAE industrial project",
        title: "Automation Panel with HMI"
      }
    ],
    faqs: [
      { question: "What types of control panels and switchgear do you manufacture?", answer: "We build PLC panels, control panels, MCC panels, relay logic panels, automation enclosures, and support low-voltage switchgear requirements for UAE and Africa projects." },
      { question: "Do you provide drawings and documentation?", answer: "Yes. We can provide GA drawings, schematics, terminal schedules, labeling, and as-built documentation based on project scope." },
      { question: "Can you support FAT and site commissioning in UAE and Africa?", answer: "Yes. We support panel testing, FAT participation, punch list closure, and coordination during installation and startup for UAE and Africa projects." }
    ],
    ctaTitle: "Need a Control Panel or Switchgear Package?",
    ctaText: "Share your control panel or low-voltage switchgear requirements and we’ll help you move from design through fabrication, testing, and site support."
  },
  "testing-commissioning": {
    slug: "testing-commissioning",
    title: "Testing, Commissioning & Site Support",
    seoTitle: "Testing & Commissioning Services UAE | FAT SAT Site Support",
    seoDescription: "Testing, commissioning, loop checking, troubleshooting, and site support services in UAE for PLC, SCADA, BMS, and control panel projects.",
    keywords: "commissioning services UAE, FAT SAT support UAE, loop checking UAE, PLC troubleshooting UAE, site support automation Africa",
    heroImage: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=1920&h=600&fit=crop&q=80",
    heroDescription: "Practical field support for testing, troubleshooting, loop checking, startup, and stable handover of automation systems.",
    introTitle: "Field Execution That Gets Systems Running Cleanly",
    introBody: [
      "Commissioning is where design quality and field reality meet. Hexalogix supports testing and commissioning for automation projects with a disciplined approach to verification, punch list closure, startup sequencing, and site troubleshooting.",
      "We work closely with electrical teams, instrument technicians, operators, and project stakeholders to move systems from installation status to stable operation with less rework and clearer accountability."
    ],
    highlightPoints: [
      "Pre-commissioning checks, loop testing, I/O verification, and functional testing",
      "PLC, SCADA, HMI, drives, instrumentation, and panel-level troubleshooting",
      "FAT, SAT, startup support, and on-site modifications",
      "Clear reporting, issue tracking, and handover assistance"
    ],
    expertiseTitle: "Commissioning Support Areas",
    expertiseItems: [
      { title: "Loop & I/O Checks", description: "Verification of field devices, addressing, signal integrity, and control responses before live operation.", bullets: ["Analog and digital loop checks", "I/O validation", "Device communication checks"] },
      { title: "Functional Testing", description: "Structured testing of process logic, interlocks, alarms, permissives, and operational sequences.", bullets: ["Cause and effect testing", "Alarm verification", "Sequence validation"] },
      { title: "Startup Support", description: "Hands-on support during energization, startup, tuning, and initial operating runs.", bullets: ["Field troubleshooting", "Operator support", "Punch list closeout"] }
    ],
    industriesTitle: "Typical Project Environments",
    industries: ["Industrial Plants", "Utilities", "Building Services", "Marine Systems", "Infrastructure", "Process Facilities", "OEM Equipment", "Retrofit Projects"],
    processTitle: "How We Support Commissioning",
    process: [
      { step: "01", title: "Readiness Review", desc: "We verify documentation, panel status, field completion, and commissioning prerequisites." },
      { step: "02", title: "Testing", desc: "Our team carries out loop checks, device verification, and functional testing against the control philosophy." },
      { step: "03", title: "Startup", desc: "We support energization, system startup, tuning, and rapid fault resolution on site." },
      { step: "04", title: "Handover", desc: "Final reports, issue closure, and operator or maintenance coordination complete the project closeout." }
    ],
    caseStudy: {
      title: "Commissioning Support for Multi-System Upgrade",
      description: "We supported testing and startup for an automation upgrade involving control panels, PLC modifications, field instruments, and HMI revisions, helping the site achieve a smoother transition to operation.",
      metrics: [
        { label: "Systems Tested", value: "20+" },
        { label: "Loop Checks", value: "500+" },
        { label: "Site Support", value: "24/7" },
        { label: "Startup Result", value: "Stable Handover" }
      ]
    },
    faqs: [
      { question: "Do you handle FAT and SAT support?", answer: "Yes. We support both factory acceptance testing and site acceptance testing, including punch item tracking and corrections." },
      { question: "Can you troubleshoot live site issues?", answer: "Yes. We provide on-site troubleshooting for PLC, HMI, SCADA, VFD, panel, and instrumentation-related issues during commissioning and startup." },
      { question: "Do you support only Hexalogix-built systems?", answer: "No. We can also support third-party systems when the project requires commissioning, testing, or modification support." }
    ],
    ctaTitle: "Need Stronger Support During Testing and Startup?",
    ctaText: "Bring us in for loop checks, troubleshooting, SAT, startup support, and a smoother commissioning phase."
  },
  turnkey: {
    slug: "turnkey",
    title: "Turnkey Automation Solutions",
    seoTitle: "Turnkey Automation Solutions UAE | Design to Commissioning",
    seoDescription: "Turnkey automation solutions in UAE covering design, programming, panel manufacturing, testing, commissioning, and project documentation.",
    keywords: "turnkey automation solutions UAE, automation contractor UAE, PLC SCADA panel turnkey UAE, industrial automation project execution Africa",
    heroImage: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1920&h=600&fit=crop&q=80",
    heroDescription: "End-to-end automation project delivery covering engineering, programming, fabrication, testing, commissioning, and documentation under one team.",
    introTitle: "One Delivery Partner from Design to Handover",
    introBody: [
      "Turnkey execution reduces coordination gaps and keeps technical ownership clear across the project lifecycle. Hexalogix delivers integrated automation packages that combine engineering, PLC and SCADA development, panel manufacturing, site execution, and commissioning.",
      "This model is especially valuable for clients who want a single accountable partner to manage technical interfaces, documentation, quality control, and delivery milestones from concept through handover."
    ],
    highlightPoints: [
      "Single-vendor responsibility for automation engineering and execution",
      "Control system design, software development, panel manufacturing, and commissioning",
      "Documentation, FAT support, and technical coordination across disciplines",
      "Suitable for new projects, expansions, and retrofit packages"
    ],
    expertiseTitle: "Turnkey Delivery Scope",
    expertiseItems: [
      { title: "Engineering & Design", description: "Upfront planning for architecture, I/O, controls, panel layouts, interfaces, and documentation standards.", bullets: ["Design reviews", "Control philosophy support", "System architecture"] },
      { title: "Build & Integrate", description: "We develop software, build panels, integrate field devices, and coordinate project execution with site stakeholders.", bullets: ["PLC and SCADA development", "Panel fabrication", "Vendor coordination"] },
      { title: "Test & Handover", description: "Structured testing, commissioning, and documentation close out the project with clear operational readiness.", bullets: ["FAT/SAT support", "Startup and tuning", "As-built handover"] }
    ],
    industriesTitle: "Turnkey Projects for Sectors Like",
    industries: ["Manufacturing", "Utilities", "Commercial Facilities", "Marine & Offshore", "Infrastructure", "Energy", "Water Systems", "Industrial Plants"],
    processTitle: "Our Turnkey Execution Model",
    process: [
      { step: "01", title: "Scope Definition", desc: "We review project intent, technical interfaces, timelines, and required deliverables." },
      { step: "02", title: "Integrated Execution", desc: "Engineering, software, panels, and site preparation move forward under one coordinated plan." },
      { step: "03", title: "Testing & Deployment", desc: "We test the package, install or integrate it, and support commissioning and startup." },
      { step: "04", title: "Documentation & Support", desc: "Final records, training inputs, and post-handover support complete the project." }
    ],
    caseStudy: {
      title: "Integrated Automation Package Delivery",
      description: "We executed a turnkey automation package covering panel engineering, PLC/SCADA programming, testing, documentation, and commissioning support for a time-sensitive industrial project.",
      metrics: [
        { label: "Execution Model", value: "Single Vendor" },
        { label: "Project Stages", value: "End-to-End" },
        { label: "Documentation", value: "Complete" },
        { label: "Site Outcome", value: "Commissioned" }
      ]
    },
    faqs: [
      { question: "What is included in a turnkey automation project?", answer: "Typical scope includes engineering, programming, panel manufacturing, integration, testing, commissioning, and project documentation." },
      { question: "Can you handle retrofit turnkey jobs?", answer: "Yes. We support both greenfield and retrofit projects, including legacy modernization and phased upgrade work." },
      { question: "Why choose a turnkey automation partner?", answer: "A turnkey model reduces interface gaps, simplifies coordination, and gives you one technical owner from design through commissioning." }
    ],
    ctaTitle: "Looking for a Turnkey Automation Partner?",
    ctaText: "Let’s plan an end-to-end delivery model that keeps engineering, fabrication, software, and commissioning aligned."
  }
};

export const locationPages = {
  'plc-programming-uae': {
    slug: 'plc-programming-uae',
    serviceSlug: 'plc',
    region: 'UAE',
    title: 'PLC Programming Services in UAE',
    seoTitle: 'PLC Programming Services in UAE | Hexalogix Automation',
    seoDescription: 'PLC programming services in UAE for industrial automation projects. Hexalogix supports new systems, retrofits, commissioning, and troubleshooting across UAE.',
    keywords: 'PLC programming services UAE, PLC programmer UAE, industrial automation UAE, Siemens PLC UAE, Allen Bradley PLC UAE',
    heroTitle: 'PLC Programming Services in UAE',
    heroText: 'Structured, reliable PLC programming for manufacturing, utilities, HVAC, marine, and infrastructure projects across the UAE.',
    heroImage: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1920&h=600&fit=crop&q=80',
    introTitle: 'Built for UAE Industrial Projects',
    introBody: [
      'Hexalogix Automation delivers PLC programming services for clients across the UAE, supporting everything from new automation packages to retrofit and expansion work. We work with Siemens, Allen Bradley, Schneider, and Delta platforms based on project requirements and plant standards.',
      'Our approach focuses on dependable control logic, clean diagnostics, easier maintenance, and practical commissioning support. That matters when uptime, safety, and field execution quality directly affect delivery.'
    ],
    valuePoints: [
      'Programming support for new systems, upgrades, and shutdown modifications',
      'UAE-ready site coordination for testing, startup, and commissioning',
      'Integration with SCADA, HMI, VFDs, panels, and field instrumentation',
      'Suitable for manufacturing, utilities, HVAC, marine, and infrastructure work'
    ],
    marketTitle: 'Why Clients in UAE Choose This Service',
    marketPoints: [
      { title: 'Fast project coordination', desc: 'We support engineering and execution needs for UAE project timelines, shutdown windows, and staged commissioning.' },
      { title: 'Multi-platform capability', desc: 'We work across the PLC brands most commonly used in UAE industrial and commercial automation projects.' },
      { title: 'Field-ready support', desc: 'From FAT and SAT through startup and tuning, our delivery model is built around real commissioning conditions.' }
    ],
    industryTitle: 'Common UAE Applications',
    industries: ['Manufacturing', 'HVAC Plants', 'Utilities', 'Water Treatment', 'Infrastructure', 'Food & Beverage', 'Marine & Offshore', 'Commercial Facilities'],
    faqTitle: 'PLC Programming in UAE FAQs',
    faqs: [
      { question: 'Do you support PLC commissioning across UAE?', answer: 'Yes. We support FAT, SAT, startup, troubleshooting, and site modifications for projects across the UAE.' },
      { question: 'Which PLC brands do you work with in UAE projects?', answer: 'We commonly support Siemens, Allen Bradley, Schneider Electric, and Delta platforms based on project scope and installed systems.' },
      { question: 'Can you retrofit an existing control system?', answer: 'Yes. We handle PLC upgrades, logic modifications, expansion work, and migration from older systems.' }
    ],
    ctaTitle: 'Need PLC Programming Support in UAE?',
    ctaText: 'Talk to Hexalogix Automation about new systems, retrofit work, troubleshooting, and commissioning support in the UAE.'
  },
  'scada-development-uae': {
    slug: 'scada-development-uae',
    serviceSlug: 'scada',
    region: 'UAE',
    title: 'SCADA Development Services in UAE',
    seoTitle: 'SCADA Development Services in UAE | Hexalogix Automation',
    seoDescription: 'SCADA development services in UAE for real-time monitoring, historian setup, alarms, dashboards, and process visibility across industrial systems.',
    keywords: 'SCADA development UAE, SCADA integrator UAE, SCADA programming UAE, industrial monitoring systems UAE, HMI SCADA UAE',
    heroTitle: 'SCADA Development Services in UAE',
    heroText: 'Operator-focused SCADA systems for monitoring, alarms, historian reporting, and plant-wide visibility across UAE automation projects.',
    heroImage: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=1920&h=600&fit=crop&q=80',
    introTitle: 'Real-Time Visibility for UAE Operations',
    introBody: [
      'For industrial and utility projects in the UAE, a well-designed SCADA layer improves operator response, alarm handling, and management visibility. Hexalogix develops SCADA systems that connect PLCs, meters, RTUs, drives, and field devices into one practical interface.',
      'We focus on clean screen design, useful alarm structures, historical trending, reporting, and remote visibility so the system is actually helpful in day-to-day operations.'
    ],
    valuePoints: [
      'Custom mimic screens, navigation, alarms, trends, and historian configuration',
      'Integration with PLC, HMI, meters, analyzers, and utility equipment',
      'Multi-area or multi-site monitoring where operational visibility matters',
      'Upgrade support for outdated SCADA environments and operator interfaces'
    ],
    marketTitle: 'Why SCADA Projects Matter in UAE',
    marketPoints: [
      { title: 'Operational visibility', desc: 'Teams need clear, fast access to live data, alarms, and historical trends across facilities and utility systems.' },
      { title: 'Scalable integration', desc: 'UAE projects often combine multiple vendors and subsystems, so interface clarity and structured integration become critical.' },
      { title: 'Management reporting', desc: 'SCADA is often expected to support not just operators, but also reporting, energy review, and site-wide monitoring.' }
    ],
    industryTitle: 'Typical UAE SCADA Use Cases',
    industries: ['Utilities', 'Water & Wastewater', 'Manufacturing', 'Energy', 'HVAC Plants', 'Infrastructure', 'Commercial Complexes', 'Marine Systems'],
    faqTitle: 'SCADA Development in UAE FAQs',
    faqs: [
      { question: 'Do you integrate SCADA with existing PLC systems?', answer: 'Yes. We integrate SCADA with new and existing PLC, RTU, HMI, and field-device environments based on project needs.' },
      { question: 'Can you upgrade an older SCADA system?', answer: 'Yes. We modernize graphics, alarms, trends, and reporting while helping preserve practical parts of the installed architecture where possible.' },
      { question: 'Do you provide commissioning and operator support?', answer: 'Yes. We support testing, commissioning, validation, and operator familiarization during deployment.' }
    ],
    ctaTitle: 'Planning a SCADA Project in UAE?',
    ctaText: 'Let’s build a monitoring platform that gives your operators and managers better visibility, cleaner alarms, and practical reporting.'
  },
  'bms-company-uae': {
    slug: 'bms-company-uae',
    serviceSlug: 'bms',
    region: 'UAE',
    title: 'BMS & HVAC Automation Company in UAE',
    seoTitle: 'BMS & HVAC Automation Company in UAE | Hexalogix Automation',
    seoDescription: 'BMS and HVAC automation services in UAE for smart control of air handling, chilled water systems, utilities, and energy monitoring.',
    keywords: 'BMS company UAE, HVAC automation UAE, building management system UAE, smart building controls UAE, BMS integrator UAE',
    heroTitle: 'BMS & HVAC Automation Company in UAE',
    heroText: 'Smarter control of HVAC, utilities, and building systems for commercial, industrial, and critical facilities across the UAE.',
    heroImage: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1920&h=600&fit=crop&q=80',
    introTitle: 'Practical Building Automation for UAE Facilities',
    introBody: [
      'Hexalogix Automation delivers BMS and HVAC automation solutions for facilities across the UAE, helping project teams improve comfort, visibility, and energy performance. We support control strategies for AHUs, FCUs, chilled water systems, pumps, fans, metering, and building-level monitoring.',
      'Our BMS work is designed to be practical for operators and facility teams, with clear graphics, dependable alarms, and meaningful performance visibility.'
    ],
    valuePoints: [
      'HVAC automation for airside and waterside systems',
      'Energy monitoring, scheduling, and utility visibility',
      'Better alarm handling and centralized facility monitoring',
      'Support for retrofits as well as new building automation scopes'
    ],
    marketTitle: 'Why This Matters for UAE Buildings',
    marketPoints: [
      { title: 'Energy performance', desc: 'Facilities need better control and monitoring to reduce waste and improve operating efficiency.' },
      { title: 'Reliable comfort control', desc: 'BMS strategy directly affects temperature stability, response quality, and equipment runtime behavior.' },
      { title: 'Centralized visibility', desc: 'Building teams need usable alarms, graphics, and dashboards rather than fragmented subsystem views.' }
    ],
    industryTitle: 'Typical UAE BMS Applications',
    industries: ['Commercial Buildings', 'Hotels', 'Hospitals', 'Data Centers', 'Industrial Facilities', 'Educational Campuses', 'Retail Complexes', 'Mixed-Use Projects'],
    faqTitle: 'BMS in UAE FAQs',
    faqs: [
      { question: 'What systems can you integrate into a BMS?', answer: 'We commonly integrate HVAC equipment, pumps, meters, utility-related controls, and other selected building systems based on scope.' },
      { question: 'Do you handle BMS retrofits?', answer: 'Yes. We support upgrades to older building systems, including graphics, control logic, visibility, and integration improvements.' },
      { question: 'Can BMS reduce operating cost?', answer: 'Yes. Better scheduling, visibility, and control logic often improve energy and maintenance performance significantly.' }
    ],
    ctaTitle: 'Looking for a BMS Company in UAE?',
    ctaText: 'Tell us about your building or facility and we’ll help define the right BMS and HVAC automation approach.'
  },
  'industrial-automation-africa': {
    slug: 'industrial-automation-africa',
    serviceSlug: 'turnkey',
    region: 'Africa',
    title: 'Industrial Automation Solutions in Africa',
    seoTitle: 'Industrial Automation Solutions in Africa | Hexalogix Automation',
    seoDescription: 'Industrial automation solutions in Africa covering PLC, SCADA, control panels, testing, commissioning, and turnkey project support.',
    keywords: 'industrial automation Africa, PLC SCADA Africa, control panel solutions Africa, commissioning support Africa, turnkey automation Africa',
    heroTitle: 'Industrial Automation Solutions in Africa',
    heroText: 'Automation support for African projects covering PLC systems, SCADA, panels, commissioning, and integrated delivery support.',
    heroImage: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1920&h=600&fit=crop&q=80',
    introTitle: 'Regional Support for Multi-Market Automation Projects',
    introBody: [
      'Hexalogix Automation supports industrial automation projects in Africa with a mix of engineering, panel integration, software development, and commissioning assistance. This is especially valuable where project teams need one partner that can help coordinate automation scope across multiple stages of delivery.',
      'We focus on practical execution: structured control logic, reliable monitoring, field-ready panel solutions, and support during testing and startup.'
    ],
    valuePoints: [
      'Support for PLC, SCADA, control panel, and commissioning scopes',
      'Useful for new projects, upgrades, and multi-system retrofit work',
      'Strong fit for remote coordination with site execution requirements',
      'Turnkey-style delivery support where multiple interfaces need to stay aligned'
    ],
    marketTitle: 'Why a Unified Partner Helps in Africa Projects',
    marketPoints: [
      { title: 'Interface control', desc: 'Projects can involve multiple contractors and vendors, so one strong automation partner reduces technical gaps.' },
      { title: 'Commissioning readiness', desc: 'Reliable testing and startup support helps reduce delays and late-stage rework.' },
      { title: 'Flexible delivery model', desc: 'Some projects need focused engineering support, while others benefit from broader turnkey-style coordination.' }
    ],
    industryTitle: 'Relevant Sectors Across Africa',
    industries: ['Manufacturing', 'Utilities', 'Water Systems', 'Infrastructure', 'Energy', 'Commercial Facilities', 'Marine & Offshore', 'Process Industries'],
    faqTitle: 'Industrial Automation in Africa FAQs',
    faqs: [
      { question: 'What automation services do you support for Africa projects?', answer: 'We support PLC programming, SCADA development, control panel solutions, testing, commissioning, and broader turnkey automation scopes.' },
      { question: 'Can you support multi-country or remote-coordination projects?', answer: 'Yes. Our delivery model can support engineering, integration, and commissioning coordination for projects that involve regional execution needs.' },
      { question: 'Do you only handle turnkey work in Africa?', answer: 'No. We can support both full integrated packages and focused scopes such as PLC, SCADA, panels, or commissioning support.' }
    ],
    ctaTitle: 'Need Industrial Automation Support for an Africa Project?',
    ctaText: 'Share your project scope and we’ll help identify the right mix of PLC, SCADA, panel, testing, and commissioning support.'
  }
};

export const testimonials = [
  {
    id: 1,
    name: "Ahmed Al-Mansoori",
    position: "Project Manager, Data Center",
    content: "Hexalogix Automation delivered exceptional control panel solutions for our data center project in KSA. Their technical expertise and professional approach exceeded our expectations.",
    rating: 5
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    position: "Engineering Manager, Marine Sector",
    content: "We've worked with Hexalogix on multiple vessel automation projects. Their marine automation expertise and reliable support have been invaluable to our operations.",
    rating: 5
  },
  {
    id: 3,
    name: "Mohammed Hassan",
    position: "Facility Director, UAE",
    content: "The BMS integration and energy management system implemented by Hexalogix has significantly improved our building efficiency and reduced operational costs.",
    rating: 5
  }
];

export const stats = [
  { label: "Projects Completed", value: "500+" },
  { label: "Years of Experience", value: "5+" },
  { label: "Industries Served", value: "10+" }
];

export const aboutContent = {
  mission: "To drive progress through innovation, precision, and dedication in automation and electrical engineering solutions, delivering world-class service to industries across the Middle East, Africa, and beyond.",
  vision: "To be the leading automation solution provider recognized globally for excellence, reliability, and customer-focused service in industrial, marine, and energy sectors.",
  values: [
    {
      title: "Quality",
      description: "We maintain the highest standards in every project, ensuring reliable and efficient automation solutions."
    },
    {
      title: "Innovation",
      description: "We stay at the forefront of automation technology to deliver cutting-edge solutions for our clients."
    },
    {
      title: "Integrity",
      description: "We build lasting relationships through transparency, honesty, and ethical business practices."
    },
    {
      title: "Customer Focus",
      description: "We prioritize client satisfaction with tailored solutions and dedicated support throughout the project lifecycle."
    }
  ],
  story: `Hexalogix Automation is a unified platform of three integrated entities working as one delivery team:

• In 2019, Hexalogix Automation was established in India, providing PLC/HMI programming, electrical design, and technical support.
• In 2024, HLA Technical Services was launched in Dubai to support on-site execution and maintenance.
• In 2025, Hexalogix Automation & Switchgear Manufacturing was established in Ajman for control panel and low-voltage switchgear manufacturing.

We deliver end-to-end solutions together, combining engineering design, field execution, and manufacturing capability for our clients.`,
  image: "/team-collaboration.webp"
};

export const heroContent = {
  title: "Precision, Power, Performance",
  subtitle: "World-class automation, control panel design & manufacturing solutions for industrial, marine, and energy sectors across UAE, Africa, and beyond.",
  image: "/hero-desktop.webp",
  cta: {
    primary: "Get in Touch",
    secondary: "Our Services"
  }
};

export const industries = [
  { name: "Oil & Gas", image: "/industry-oil-gas.webp" },
  { name: "Marine & Offshore", image: "/industry-marine-offshore.webp" },
  { name: "Industrial & Commercial", image: "/industry-industrial-commercial.webp" },
  { name: "Transportation", image: "/industry-transportation.webp" },
  { name: "Pharmaceuticals", image: "/industry-pharmaceuticals.webp" },
  { name: "Renewable Energy", image: "/industry-renewable-energy.webp" },
  { name: "Data Centers", image: "/industry-data-centers.webp" },
  { name: "Hospitality", image: "/industry-hospitality.webp" },
  { name: "Healthcare", image: "/industry-healthcare.webp" },
  { name: "Infrastructure", image: "/industry-infrastructure.webp" }
];

export const partners = [
  { name: "Siemens", logo: "/SIEMENS.webp" },
  { name: "Schneider Electric", logo: "/SCHNEIDER.webp" },
  { name: "ABB", logo: "/ABB.webp" },
  { name: "Rittal", logo: "/RITTAL.webp" },
  { name: "Weidmüller", logo: "/WEIDMULLER.webp" },
  { name: "Allen-Bradley", logo: null },
  { name: "Delta Electronics", logo: "/DELTA.webp" }
];

// Contact form submission - calls backend API
export const blogPosts = [
  {
    id: 1,
    slug: 'what-is-plc-industrial-automation',
    title: 'What is PLC in Industrial Automation?',
    excerpt: 'Complete guide to Programmable Logic Controllers (PLCs) - the backbone of modern industrial automation systems.',
    category: 'PLC & Automation',
    date: 'April 15, 2026',
    readTime: '8 min read',
    color: 'from-[#0A1628] to-[#0D2146]',
    relatedServices: ['plc', 'scada', 'testing-commissioning'],
    content: [
      { type: 'paragraph', text: 'PLC (Programmable Logic Controller) is the heart of modern industrial automation. This comprehensive guide explains what PLCs are, how they work, and why they are essential for industrial automation.' }
    ]
  },
  {
    id: 2,
    slug: 'scada-vs-plc-differences',
    title: 'SCADA vs PLC – Key Differences Explained',
    excerpt: 'Understanding the differences between SCADA systems and PLC controllers for industrial automation projects.',
    category: 'SCADA & HMI',
    date: 'April 12, 2026',
    readTime: '6 min read',
    color: 'from-[#071A30] to-[#0A2A4A]',
    relatedServices: ['scada', 'plc', 'testing-commissioning'],
    content: [
      { type: 'paragraph', text: 'SCADA and PLC are both crucial components of industrial automation, but they serve different purposes. Learn the key differences and when to use each technology.' }
    ]
  },
  {
    id: 3,
    slug: 'what-is-bms-system-hvac',
    title: 'What is BMS System in HVAC?',
    excerpt: 'Building Management Systems (BMS) explained - how they optimize HVAC, lighting, and energy management in modern buildings.',
    category: 'BMS & HVAC',
    date: 'April 10, 2026',
    readTime: '7 min read',
    color: 'from-[#0A1628] to-[#0D2146]',
    relatedServices: ['bms', 'turnkey', 'testing-commissioning'],
    content: [
      { type: 'paragraph', text: 'Building Management Systems (BMS) are intelligent control systems that manage HVAC, lighting, security, and other building systems for optimal performance and energy efficiency.' }
    ]
  },
  {
    id: 4,
    slug: 'top-5-plc-brands-uae',
    title: 'Top 5 PLC Brands Used in UAE',
    excerpt: 'Siemens, Schneider, Allen Bradley - discover the most popular PLC brands in UAE industrial automation projects.',
    category: 'PLC & Automation',
    date: 'April 8, 2026',
    readTime: '5 min read',
    color: 'from-[#071A30] to-[#0A2A4A]',
    relatedServices: ['plc', 'control-panels', 'testing-commissioning'],
    content: [
      { type: 'paragraph', text: 'The UAE industrial sector relies on world-class PLC brands. Here are the top 5 PLC manufacturers commonly used in UAE automation projects.' }
    ]
  },
  {
    id: 5,
    slug: 'industrial-automation-benefits-manufacturing',
    title: 'Benefits of Industrial Automation for Manufacturing',
    excerpt: 'How industrial automation improves efficiency, reduces costs, and increases productivity in manufacturing operations.',
    category: 'Industrial Automation',
    date: 'April 5, 2026',
    readTime: '6 min read',
    color: 'from-[#0A1628] to-[#0D2146]',
    relatedServices: ['turnkey', 'plc', 'control-panels'],
    content: [
      { type: 'paragraph', text: 'Industrial automation offers numerous benefits for manufacturing companies including improved efficiency, cost reduction, quality control, and increased productivity.' }
    ]
  },
  {
    id: 6,
    slug: 'how-plc-programming-works',
    title: 'How PLC Programming Works Step-by-Step',
    excerpt: 'Complete guide to PLC programming process - from ladder logic to commissioning and testing.',
    category: 'PLC & Automation',
    date: 'April 1, 2026',
    readTime: '10 min read',
    color: 'from-[#071A30] to-[#0A2A4A]',
    relatedServices: ['plc', 'testing-commissioning', 'scada'],
    content: [
      { type: 'paragraph', text: 'Learn the complete PLC programming process from requirements gathering to final commissioning. Step-by-step guide for industrial automation projects.' }
    ]
  },
  {
    id: 7,
    slug: 'bms-system-cost-uae',
    title: 'Cost of BMS System in UAE',
    excerpt: 'Understanding Building Management System costs in UAE - factors affecting pricing and ROI calculations.',
    category: 'BMS & HVAC',
    date: 'March 28, 2026',
    readTime: '7 min read',
    color: 'from-[#0A1628] to-[#0D2146]',
    relatedServices: ['bms', 'turnkey', 'control-panels'],
    content: [
      { type: 'paragraph', text: 'Building Management System costs in UAE vary based on building size, complexity, and features. Learn about pricing factors and return on investment.' }
    ]
  },
  {
    id: 8,
    slug: 'industrial-automation-trends-uae-2026',
    title: 'Industrial Automation Trends in UAE 2026',
    excerpt: 'Latest trends shaping industrial automation in UAE - IoT, AI, Industry 4.0, and digital transformation.',
    category: 'Industry Trends',
    date: 'March 25, 2026',
    readTime: '8 min read',
    color: 'from-[#071A30] to-[#0A2A4A]',
    relatedServices: ['turnkey', 'scada', 'plc'],
    content: [
      { type: 'paragraph', text: 'The UAE industrial sector is embracing new automation technologies. Discover the key trends that will shape industrial automation in 2026.' }
    ]
  },
  {
    id: 9,
    slug: 'scada-efficiency-factories',
    title: 'How SCADA Improves Efficiency in Factories',
    excerpt: 'SCADA systems enhance factory operations through real-time monitoring, data analysis, and automated control.',
    category: 'SCADA & HMI',
    date: 'March 22, 2026',
    readTime: '6 min read',
    color: 'from-[#0A1628] to-[#0D2146]',
    relatedServices: ['scada', 'plc', 'turnkey'],
    content: [
      { type: 'paragraph', text: 'SCADA systems provide comprehensive monitoring and control capabilities that significantly improve factory efficiency and productivity.' }
    ]
  },
  {
    id: 10,
    slug: 'common-plc-programming-mistakes',
    title: 'Common PLC Programming Mistakes',
    excerpt: 'Avoid these common pitfalls in PLC programming that can lead to system failures and costly downtime.',
    category: 'PLC & Automation',
    date: 'March 20, 2026',
    readTime: '5 min read',
    color: 'from-[#071A30] to-[#0A2A4A]',
    relatedServices: ['plc', 'testing-commissioning', 'control-panels'],
    content: [
      { type: 'paragraph', text: 'Even experienced programmers make mistakes. Learn about the most common PLC programming errors and how to avoid them.' }
    ]
  },
  {
    id: 11,
    slug: 'choose-automation-company-uae',
    title: 'How to Choose an Automation Company in UAE',
    excerpt: 'Essential factors to consider when selecting an industrial automation partner in UAE - certifications, experience, support.',
    category: 'Business Guide',
    date: 'March 15, 2026',
    readTime: '7 min read',
    color: 'from-[#0A1628] to-[#0D2146]',
    relatedServices: ['turnkey', 'plc', 'control-panels'],
    content: [
      { type: 'paragraph', text: 'Choosing the right automation company is crucial for project success. Learn what to look for when selecting an automation partner in UAE.' }
    ]
  },
  {
    id: 12,
    slug: 'plc-programming-services-uae-guide',
    title: 'PLC Programming Services in UAE - Complete Guide',
    excerpt: 'Everything you need to know about PLC programming services in UAE - costs, timelines, and choosing the right provider.',
    category: 'Services Guide',
    date: 'March 12, 2026',
    readTime: '9 min read',
    color: 'from-[#071A30] to-[#0A2A4A]',
    relatedServices: ['plc', 'scada', 'testing-commissioning'],
    content: [
      { type: 'paragraph', text: 'Comprehensive guide to PLC programming services in UAE - from understanding requirements to project completion and support.' }
    ]
  },
  {
    id: 13,
    slug: 'best-control-panel-manufacturers-uae',
    title: 'Best Control Panel Manufacturers in UAE',
    excerpt: 'Top control panel manufacturers in UAE - quality standards, certifications, and factors to consider for your project.',
    category: 'Control Panels',
    date: 'March 10, 2026',
    readTime: '6 min read',
    color: 'from-[#0A1628] to-[#0D2146]',
    relatedServices: ['control-panels', 'testing-commissioning', 'turnkey'],
    content: [
      { type: 'paragraph', text: 'Finding the right control panel manufacturer is essential for automation projects. Discover the best manufacturers in UAE.' }
    ]
  },
  {
    id: 14,
    slug: 'hvac-automation-project-case-study',
    title: 'Case Study: HVAC Automation Project',
    excerpt: 'Real-world case study of successful HVAC automation implementation - challenges, solutions, and results achieved.',
    category: 'Case Studies',
    date: 'March 8, 2026',
    readTime: '8 min read',
    color: 'from-[#071A30] to-[#0A2A4A]',
    relatedServices: ['bms', 'turnkey', 'testing-commissioning'],
    content: [
      { type: 'paragraph', text: 'Detailed case study of an HVAC automation project showing how proper planning and execution deliver outstanding results.' }
    ]
  },
  {
    id: 15,
    slug: 'why-businesses-need-bms-uae',
    title: 'Why Businesses in UAE Need BMS Systems',
    excerpt: 'Benefits of Building Management Systems for UAE businesses - energy savings, operational efficiency, and regulatory compliance.',
    category: 'BMS & HVAC',
    date: 'March 5, 2026',
    readTime: '7 min read',
    color: 'from-[#0A1628] to-[#0D2146]',
    relatedServices: ['bms', 'turnkey', 'control-panels'],
    content: [
      { type: 'paragraph', text: 'Building Management Systems offer significant benefits for businesses in UAE including energy cost reduction and improved operational efficiency.' }
    ]
  }
];

export const submitContactForm = async (formData) => {
  try {
    const emailjs = await import('@emailjs/browser');
    await emailjs.send(
      'service_xhpzduc',
      'template_wqlbk0l',
      {
        from_name: formData.name,
        from_email: formData.email,
        phone: formData.phone || 'Not provided',
        company: formData.company || 'Not provided',
        service: formData.service || 'Not specified',
        project_location: formData.projectLocation || 'Not specified',
        industry: formData.industry || 'Not specified',
        timeline: formData.timeline || 'Not specified',
        budget: formData.budget || 'Not specified',
        message: formData.message,
        email: formData.email,
      },
      'ZTWUrnMCeuq8cUm4g'
    );
    return { success: true, message: 'Your message has been sent successfully! We will get back to you within 24 hours.' };
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw new Error('Failed to send message. Please try again or email us directly at info@hexalogixautomation.com');
  }
};
